import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import styles from "./ProfileActions.module.scss";

type Props = {
	hasProfile: boolean;
};

const ProfileActions = ({ hasProfile }: Props) => {
	return (
		<div className={styles.self}>
			<Link to="/manage-profile" state={{ edit: true }} className={styles.link}>
				<Icon name="pencil alternate" />
				<span className={styles.linkText}>
			<FormattedMessage
				id="dashboard.profileActions.editProfile"
				defaultMessage="Edit profile"
			/>
		</span>
			</Link>

			<Link to="/manage-pattern" className={styles.link}>
				<Icon name="plus" />
				<span className={styles.linkText}>
			<FormattedMessage
				id="dashboard.profileActions.addPattern"
				defaultMessage="Add pattern"
			/>
		</span>
			</Link>

			<Link to="/studio" className={styles.link}>
				<Icon name="pencil" />
				<span className={styles.linkText}>
			<FormattedMessage
				id="dashboard.profileActions.designStudio"
				defaultMessage="Design in Studio"
			/>
		</span>
			</Link>
		</div>
	);
};

export default ProfileActions;
